import { NgModule } from '@angular/core';
import { ConstantsService } from '~core/services/constants.service';
import { SsrResponseService } from '~core/services/ssr-response.service';
import { SsrRequestService } from '~core/services/ssr-request.service';
import { ApiConstantsService } from '~core/services/api-constants.service';

const PROVIDERS = [
  ApiConstantsService,
  ConstantsService,
  SsrRequestService,
  SsrResponseService
];

@NgModule({
  providers: PROVIDERS,
  exports: []
})
export class CoreModule {}
